import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const fetchActivityLogs = async (params = {}) => {
  const response = await axios.get(`${API_URL}/support/activity-logs`, { params });
  return response.data;
};

